/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2020-02-07 16:11:07
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { SkeletonDisplayText } from '@shopify/polaris';

type Props = {};

class LoadingRows extends Component<Props> {
  render() {
    return (
      <React.Fragment>
        {[...Array(3).keys()].map((item, key) => (
          <tr key={key}>
            {[...Array(3).keys()].map((item, key) => (
              <td className="Polaris-DataTable__Cell" key={key}>
                <SkeletonDisplayText size="small" />
              </td>
            ))}
          </tr>
        ))}
      </React.Fragment>
    );
  }
}

export default LoadingRows;
